"use strict";
/**
 * 期货二级tab配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.maintabconfig = void 0;
exports.maintabconfig = {
    "#options_sh50etf": {
        "matchs": [
            "#options_sh50etf_all",
            "#options_sh50etf_call",
            "#options_sh50etf_put"
        ],
        "navbar": [
            {
                "title": "上交期权",
                "path": "#options_sh50etf_all"
            },
            {
                "title": "认购期权",
                "path": "#options_sh50etf_call"
            },
            {
                "title": "认沽期权",
                "path": "#options_sh50etf_put"
            }
        ]
    },
    "#options_sz50etf": {
        "matchs": [
            "#options_sz50etf_txbj",
            "#options_sz50etf_all",
            "#options_sz50etf_rengou",
            "#options_sz50etf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_sz50etf_txbj"
            },
            {
                "title": "50ETF全部合约",
                "path": "#options_sz50etf_all"
            },
            {
                "title": "50ETF认购合约",
                "path": "#options_sz50etf_rengou"
            },
            {
                "title": "50ETF认沽合约",
                "path": "#options_sz50etf_rengu"
            }
        ]
    },
    "#options_sahs300etf": {
        "matchs": [
            "#options_sahs300etf_txbj",
            "#options_sahs300etf_all",
            "#options_sahs300etf_rengou",
            "#options_sahs300etf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_sahs300etf_txbj"
            },
            {
                "title": "300ETF全部合约",
                "path": "#options_sahs300etf_all"
            },
            {
                "title": "300ETF认购合约",
                "path": "#options_sahs300etf_rengou"
            },
            {
                "title": "300ETF认沽合约",
                "path": "#options_sahs300etf_rengu"
            }
        ]
    },
    "#options_sazz500etf": {
        "matchs": [
            "#options_sazz500etf_txbj",
            "#options_sazz500etf_all",
            "#options_sazz500etf_rengou",
            "#options_sazz500etf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_sazz500etf_txbj"
            },
            {
                "title": "中证500ETF全部合约",
                "path": "#options_sazz500etf_all"
            },
            {
                "title": "中证500ETF认购合约",
                "path": "#options_sazz500etf_rengou"
            },
            {
                "title": "中证500ETF认沽合约",
                "path": "#options_sazz500etf_rengu"
            }
        ]
    },
    "#options_kc50etf1": {
        "matchs": [
            "#options_kc50etf1_txbj",
            "#options_kc50etf1_all",
            "#options_kc50etf1_rengou",
            "#options_kc50etf1_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_kc50etf1_txbj"
            },
            {
                "title": "科创50全部合约",
                "path": "#options_kc50etf1_all"
            },
            {
                "title": "科创50认购合约",
                "path": "#options_kc50etf1_rengou"
            },
            {
                "title": "科创50认沽合约",
                "path": "#options_kc50etf1_rengu"
            }
        ]
    },
    "#options_kc50etf2": {
        "matchs": [
            "#options_kc50etf2_txbj",
            "#options_kc50etf2_all",
            "#options_kc50etf2_rengou",
            "#options_kc50etf2_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_kc50etf2_txbj"
            },
            {
                "title": "科创板50全部合约",
                "path": "#options_kc50etf2_all"
            },
            {
                "title": "科创板50认购合约",
                "path": "#options_kc50etf2_rengou"
            },
            {
                "title": "科创板50认沽合约",
                "path": "#options_kc50etf2_rengu"
            }
        ]
    },
    "#options_sehs300etf": {
        "matchs": [
            "#options_sehs300etf_txbj",
            "#options_sehs300etf_all",
            "#options_sehs300etf_rengou",
            "#options_sehs300etf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_sehs300etf_txbj"
            },
            {
                "title": "300ETF全部合约",
                "path": "#options_sehs300etf_all"
            },
            {
                "title": "300ETF认购合约",
                "path": "#options_sehs300etf_rengou"
            },
            {
                "title": "300ETF认沽合约",
                "path": "#options_sehs300etf_rengu"
            }
        ]
    },
    "#options_sezz500etf": {
        "matchs": [
            "#options_sezz500etf_txbj",
            "#options_sezz500etf_all",
            "#options_sezz500etf_rengou",
            "#options_sezz500etf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_sezz500etf_txbj"
            },
            {
                "title": "中证500ETF全部合约",
                "path": "#options_sezz500etf_all"
            },
            {
                "title": "中证500ETF认购合约",
                "path": "#options_sezz500etf_rengou"
            },
            {
                "title": "中证500ETF认沽合约",
                "path": "#options_sezz500etf_rengu"
            }
        ]
    },
    "#options_secybetf": {
        "matchs": [
            "#options_secybetf_txbj",
            "#options_secybetf_all",
            "#options_secybetf_rengou",
            "#options_secybetf_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_secybetf_txbj"
            },
            {
                "title": "创业板ETF全部合约",
                "path": "#options_secybetf_all"
            },
            {
                "title": "创业板ETF认购合约",
                "path": "#options_secybetf_rengou"
            },
            {
                "title": "创业板ETF认沽合约",
                "path": "#options_secybetf_rengu"
            }
        ]
    },
    "#options_zjcffex": {
        "matchs": [
            "#options_zjcffex_txbj",
            "#options_zjcffex_all",
            "#options_zjcffex_rengou",
            "#options_zjcffex_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_zjcffex_txbj"
            },
            {
                "title": "300指数全部合约",
                "path": "#options_zjcffex_all"
            },
            {
                "title": "300指数认购合约",
                "path": "#options_zjcffex_rengou"
            },
            {
                "title": "300指数认沽合约",
                "path": "#options_zjcffex_rengu"
            }
        ]
    },
    "#options_zjcffex_mo": {
        "matchs": [
            "#options_zjcffex_mo_txbj",
            "#options_zjcffex_mo_all",
            "#options_zjcffex_mo_rengou",
            "#options_zjcffex_mo_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_zjcffex_mo_txbj"
            },
            {
                "title": "中证1000指数全部合约",
                "path": "#options_zjcffex_mo_all"
            },
            {
                "title": "中证1000指数认购合约",
                "path": "#options_zjcffex_mo_rengou"
            },
            {
                "title": "中证1000指数认沽合约",
                "path": "#options_zjcffex_mo_rengu"
            }
        ]
    },
    "#options_zjcffex_ho": {
        "matchs": [
            "#options_zjcffex_ho_txbj",
            "#options_zjcffex_ho_all",
            "#options_zjcffex_ho_rengou",
            "#options_zjcffex_ho_rengu"
        ],
        "navbar": [
            {
                "title": "T型报价",
                "path": "#options_zjcffex_ho_txbj"
            },
            {
                "title": "上证50指数全部合约",
                "path": "#options_zjcffex_ho_all"
            },
            {
                "title": "上证50指数认购合约",
                "path": "#options_zjcffex_ho_rengou"
            },
            {
                "title": "上证50指数认沽合约",
                "path": "#options_zjcffex_ho_rengu"
            }
        ]
    }
};
